import api from "../../../services/api";

const APIS = {
  COMPANY_LIST_DATA: "/Companies",
  REQUESTED_LIST_DATA: "/RequestList/RequestedSamplesList",
  SAMPLE_EDIT_DATA: "/RequestList/requestedListSample",
  SAMPLE_UPDATE_DATA: "/RequestList/updatesample",
  STATUS_DATA: "/RequestList/status",
  STATES_DATA: "/Location/states",
  SPECIES_DATA: "/Species",
  PRODUCT_TYPE_DATA: "/ProductTypes",
  PRINT_SAMPLE_DATA: "/Sample/printsamplespdf",
  UPDATE_LOCATION: "/Location/update-location",
  LOCATION_BY_COMPANY_ID: "/Location/locations-by-company",
  USERS_BY_LOCATION_ID: "/Location",
  UNITS_DATA: "/Units",
  //here
  GET_PRODUCT_TRADES: "/ProductTypes/getproducttrades",
  GET_PRODUCTS_BY_TRADE_ID: "/ProductTypes/getproductsbytradeid",
  GET_FEED_TYPE_BY_TRADE_AND_PRODUCT:
    "/ProductTypes/getfeedtypebytradeandproduct",
  GET_SPECIES_BY_TRADE_AND_PRODUCT_AND_FEED:
    "/ProductTypes/getspeciesbytradeandproductandfeed",
  GET_PRODUCT_CONFIGURATION: "/ProductTypes/getproductConfiguration",
};

export const getRequestedListData = async (payload = {}) => {
  try {
    const response = await api.post(APIS.REQUESTED_LIST_DATA, payload);
    return response.data;
  } catch (error) {
    console.error("Error fetching Tasks all data:", error);
    throw error;
  }
};

export const getCompanyListData = async (params = {}) => {
  try {
    const response = await api.get(APIS.COMPANY_LIST_DATA, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching company list:", error);
    throw error;
  }
};

export const getSampleEditData = async (params = {}) => {
  try {
    const response = await api.get(APIS.SAMPLE_EDIT_DATA, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching Sample Edit data:", error);
    throw error;
  }
};
export const updateSampleEditData = async (payload = {}) => {
  try {
    const response = await api.post(APIS.SAMPLE_UPDATE_DATA, payload);
    return response.data;
  } catch (error) {
    console.error("Error updating sample data:", error);
    throw error;
  }
};

export const getStatusData = async () => {
  try {
    const response = await api.get(APIS.STATUS_DATA);
    return response.data;
  } catch (error) {
    console.error("Error fetching Status data:", error);
    throw error;
  }
};

export const getStatesData = async () => {
  try {
    const response = await api.get(APIS.STATES_DATA);
    return response.data;
  } catch (error) {
    console.error("Error fetching States data:", error);
    throw error;
  }
};

export const getSpeciesData = async () => {
  try {
    const response = await api.get(APIS.SPECIES_DATA);
    return response.data;
  } catch (error) {
    console.error("Error fetching Species data:", error);
    throw error;
  }
};

export const getProductTypeData = async () => {
  try {
    const response = await api.get(APIS.PRODUCT_TYPE_DATA);
    return response.data;
  } catch (error) {
    console.error("Failed to print samples PDF:", error);
    throw error;
  }
};

export const getPrintSampleData = async (groupId, ids) => {
  try {
    // Build query string with repeated ids and groupId params
    let queryParts = [];
    if (Array.isArray(groupId)) {
      groupId.forEach((id) => {
        queryParts.push(`groupId=${encodeURIComponent(id)}`);
      });
    } else if (groupId !== undefined && groupId !== null) {
      queryParts.push(`groupId=${encodeURIComponent(groupId)}`);
    }
    if (Array.isArray(ids)) {
      ids.forEach((id) => {
        queryParts.push(`ids=${encodeURIComponent(id)}`);
      });
    } else if (ids !== undefined && ids !== null) {
      queryParts.push(`ids=${encodeURIComponent(ids)}`);
    }
    const url = `${APIS.PRINT_SAMPLE_DATA}${
      queryParts.length ? "?" + queryParts.join("&") : ""
    }`;

    const response = await api.get(url, {
      responseType: "blob",
    });

    const blob = new Blob([response.data], { type: "application/pdf" });
    const pdfUrl = window.URL.createObjectURL(blob);

    const printWindow = window.open(
      pdfUrl,
      "_blank",
      "width=900,height=700,scrollbars=yes,resizable=yes"
    );
    printWindow.focus();
  } catch (error) {
    throw error;
  }
};

export const updateLocation = async (payload = {}) => {
  try {
    const response = await api.put(APIS.UPDATE_LOCATION, payload);
    return response.data;
  } catch (error) {
    console.error("Error updating location:", error);
    throw error;
  }
};

// export const getLocationsByCompanyId = async (params = {}) => {
//   try {
//     const response = await api.get(APIS.LOCATION_BY_COMPANY_ID,  { params});
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching locations by company ID:", error);
//     throw error;
//   }
// };
export const getLocationsByCompanyId = async (companyId) => {
  try {
    const url = `${APIS.LOCATION_BY_COMPANY_ID}/${companyId}`;
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching locations by company ID:", error);
    throw error;
  }
};

export const getUsersByLocationId = async (locationId) => {
  try {
    if (!locationId || Number(locationId) <= 0) {
      throw new Error("locationId is required.");
    }

    const url = `${APIS.USERS_BY_LOCATION_ID}/${locationId}/users`;
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching users by location ID:", error);
    throw error;
  }
};

export const getUnitsData = async () => {
  try {
    const response = await api.get(APIS.UNITS_DATA);
    return response.data;
  } catch (error) {
    console.error("Failed to get units:", error);
    throw error;
  }
};
//here
export const getProductTrades = async () => {
    try {
        const response = await api.get(APIS.GET_PRODUCT_TRADES);
        if (!response.data || !Array.isArray(response.data)) {
            return [];
        }
        return response.data.filter(trade => trade && trade.productTradeNameId && trade.productTradeName);
    } catch (error) {
        console.error('Failed to fetch product trades:', error);
        return [];
    }
};

export const getProductsByTradeId = async (productTradeId) => {
    try {
        if (!productTradeId || isNaN(productTradeId)) {
            console.error(`Invalid productTradeId: ${productTradeId}`);
            return [];
        }
        const response = await api.post(`${APIS.GET_PRODUCTS_BY_TRADE_ID}?ProductTradeId=${productTradeId}`, {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.data || !Array.isArray(response.data)) {
            return [];
        }
        return response.data.filter(type => type && type.productTypeId && type.name);
    } catch (error) {
        console.error('Failed to fetch products by trade id:', error);
        return [];
    }
};

export const getFeedTypeByTradeAndProduct = async (productTradeId, productTypeId) => {
    try {
        if (!productTradeId || !productTypeId || isNaN(productTradeId) || isNaN(productTypeId)) {
            console.error(`Invalid parameters - productTradeId: ${productTradeId}, productTypeId: ${productTypeId}`);
            return [];
        }
        const response = await api.post(`${APIS.GET_FEED_TYPE_BY_TRADE_AND_PRODUCT}?ProductTradeId=${productTradeId}&ProductTypeId=${productTypeId}`, {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.data || !Array.isArray(response.data)) {
            return [];
        }
        return response.data.filter(feed => feed && feed.feedTypeId && feed.feedTypeName);
    } catch (error) {
        console.error('Failed to fetch feed types:', error);
        return [];
    }
};

export const getSpeciesByTradeAndProductAndFeed = async (productTradeId, productTypeId, feedTypeId) => {
    try {
        if (!productTradeId || !productTypeId || !feedTypeId ||
            isNaN(productTradeId) || isNaN(productTypeId) || isNaN(feedTypeId)) {
            console.error(`Invalid parameters - productTradeId: ${productTradeId}, productTypeId: ${productTypeId}, feedTypeId: ${feedTypeId}`);
            return [];
        }
        const response = await api.post(`${APIS.GET_SPECIES_BY_TRADE_AND_PRODUCT_AND_FEED}?ProductTradeId=${productTradeId}&ProductTypeId=${productTypeId}&feedTypeId=${feedTypeId}`, {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.data || !Array.isArray(response.data)) {
            return [];
        }
        return response.data.filter(s => s && s.speciesId && s.speciesName);
    } catch (error) {
        console.error('Failed to fetch species by trade, product and feed:', error);
        return [];
    }
};

export const getProductConfiguration = async (productTradeId, productTypeId, feedTypeId, speciesId) => {
    try {
        if (!productTradeId || !productTypeId || !feedTypeId || !speciesId ||
            isNaN(productTradeId) || isNaN(productTypeId) || isNaN(feedTypeId) || isNaN(speciesId)) {
            console.error(`Invalid parameters - productTradeId: ${productTradeId}, productTypeId: ${productTypeId}, feedTypeId: ${feedTypeId}, speciesId: ${speciesId}`);
            return {};
        }

        const response = await api.post(`${APIS.GET_PRODUCT_CONFIGURATION}?ProductTradeId=${productTradeId}&ProductTypeId=${productTypeId}&feedTypeId=${feedTypeId}&speciesId=${speciesId}`, {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return response.data || {};
    } catch (error) {
        console.error('Failed to fetch product configuration:', error);
        return {};
    }
};

